import React, { FC } from 'react';

import { useTheme } from '@mui/material';
import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

import InProgressIcon from '~/assets/icons/InProgressIcon';
import PlaySmallIcon from '~/assets/icons/PlaySmallIcon';
import { PRIORITY_PATHWAY_SLUG_COOKIE_NAME } from '~/const';
import {
  PreviewTitle,
  PreviewWrapper,
  StyledCheckIcon,
  VideoPreview,
} from '~/pages/SingleVideoPage/styles';
import { VideoStatus } from '~/pages/const';
import { Maybe } from '~/types';
import Cookies from '~/utils/cookies';
import sendAnalyticEvent from '~/utils/sendAnalyticEvent';

interface VideoCardProps {
  status: VideoStatus;
  link: string;
  isActive: boolean;
  pathwaySlug?: Maybe<string>;
  preview?: Maybe<string>;
  title?: string;
}

const VideoCard: FC<VideoCardProps> = ({ status, preview, title, link, isActive, pathwaySlug }) => {
  const theme = useTheme();
  const handleClick = () => {
    if (!pathwaySlug) {
      return;
    }

    sendAnalyticEvent('Video_pg_Continue');
    Cookies.set(PRIORITY_PATHWAY_SLUG_COOKIE_NAME, pathwaySlug);
  };

  return (
    <StyledLink to={link} data-testid="pathwaysVideoCard" onClick={handleClick}>
      <PreviewWrapper
        data-testid="videoPreviewWrapper"
        active={isActive}
        isNotWatched={status === VideoStatus.NotWatched}
      >
        <VideoPreview path={preview} alt="" srcset={[{ width: 120 }, { width: 80 }]} />
        {status === VideoStatus.Completed && <StyledCheckIcon data-testid="videoCompleted" />}
        {!isActive && status === VideoStatus.NotWatched && (
          <PlayIcon data-testid="videoNotWatched" color={theme.palette.secondary.contrastText} />
        )}
        {!isActive && status === VideoStatus.Watched && <ProgressIcon data-testid="videoWatched" />}
      </PreviewWrapper>
      <PreviewTitle data-testid="cardTitle">{title}</PreviewTitle>
    </StyledLink>
  );
};

export default VideoCard;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.palette.common.text.secondaryToPrimary};
  &:hover {
    color: ${({ theme }) => theme.palette.common.accent};
  }
`;
const ProgressIcon = styled(InProgressIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, -50%);
  width: 31px;
  height: 31px;
  color: ${({ theme }) => theme.palette.common.text.white};
`;
const PlayIcon = styled(PlaySmallIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
`;
